module.exports = __webpack_public_path__ + "static/media/flooring_allImpact_60yd_y.b6b3a3f2.csv";